import React, { useState, useEffect, useCallback } from 'react';import {
  LockOutlined,
  UserOutlined,
  ApartmentOutlined,
  LoginOutlined,ArrowLeftOutlined
} from '@ant-design/icons';
import { Button, Form, Input, Card, Row, Col, Typography, Image } from 'antd';
import { Navigate, useNavigate  } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Forgotpassword from '../components/Forgotpassword/Forgotpassword';
import Changepassword1 from '../Changepassword/Changepassword1';
import updated from '../../assets/images/updated.png';
import WW from '../../assets/images/WW.png';
import axios from 'axios';
import moment from 'moment';

import { ssoLogin, getDetails } from '../services/auth';

export default function Login() {
  const { user, userConfig, isUserLoading, login } = useAuth();
  const [isCaptchaVerified, setIsCaptchaVerified] = React.useState(false);
  const [forgotPasswordOpen, setforgotPasswordOpen] = React.useState(false);
  const [showForgotPasswordMobile, setShowForgotPasswordMobile] = useState(false);
  const [changePasswordOpen, setchangePasswordOpen] = React.useState(false);
  const [useridvalue, setuseridvalue] = React.useState();
  const [orgId, setOrgId] = useState('');
  const [isValidOrg, setIsValidOrg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);

  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();

  // Responsive check
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  const onFinish = (values) => {
    setuseridvalue(values.userid);

    var userType = 'New';
    userType === 'Active' ? setchangePasswordOpen(true) : login(values);
  };

  const openAdminModal = () => {
    setforgotPasswordOpen(true);
  };

  const handleSSOLogin = () => {
    //window.location.href = `http://localhost:3000/auth/saml/login?orgId=${orgId}`
    //  window.location.href = "https://demo.wikiworks.in/api/auth/saml/login"
    if(orgId.toLowerCase() === "freeman"){
      window.location.href = `${process.env.REACT_APP_FREEMAN_URL_SSO}/oauth2/authorize?response_type=code&client_id=${process.env.REACT_APP_FREEMAN_CLIENT_ID_SSO}&redirect_uri=https://test.wikiworks.in/api/auth/saml/login?orgId=FREEMAN`;
      return;
    }
    window.location.href = `https://dev.wikiworks.in/api/auth/saml/login?orgId=${orgId}`;
  };

  const handleOrgIdChange = (e) => {
    // Remove all spaces completely
    const value = e.target.value.replace(/\s/g, '');
    setOrgId(value);

    // Clear previous timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Only validate if there's input
    if (value.length > 0) {
      setTypingTimeout(
        setTimeout(() => {
          validateOrgId(value);
        }, 1000) // 1000ms debounce delay
      );
    } else {
      setIsValidOrg(false);
    }
  };

  const validateOrganisationId = async (orgId) => {
    try {
      const response = await axios.get(
        // 'http://localhost:3000/api/validate-orgId', 
        `${process.env.REACT_APP_API_URL}/validate-orgId`,
      {
        params: { orgId }  // For GET requests
      });
      return response.data.result;
    } catch (error) {
      console.error('Validation error:', error);
      return false;
    }
  };
  

  const validateOrgId = useCallback(async (id) => {
    setLoading(true);
    try {
      const isValid = await validateOrganisationId(id);
      setIsValidOrg(isValid);
    } catch (error) {
      console.error('Validation failed:', error);
      setIsValidOrg(false);
    } finally {
      setLoading(false);
    }
  }, []);

  if (user.isAuthenticated && !user?.userConfig?.isPasswordChanged) {
    return <Navigate to='/home/change-password' />;
  } else if (user.isAuthenticated) {
    getDetails(user?.userConfig?.orgId)
      .then((response) => {
        let rolePermission;
        const normalize = (str) => str?.toLowerCase().replace(/[_\s]/g, '');

        if (userConfig?.orgId?.toLowerCase() === 'freeman' && userConfig?.role === 'supervisor') {
          navigate('/home/events');
          return;
        }

        // Determine the correct role object based on userConfig
        if (userConfig.role === 'approver') {
          if (userConfig.level === 1) {
            rolePermission = response?.data.find(
              (item) =>
                item.selectedRole === 'Approver' &&
                normalize(item.selectedRoleType) === normalize('HR Admin')
            );
          } else if (userConfig.level === 2) {
            rolePermission = response?.data.find(
              (item) =>
                item.selectedRole === 'Approver' &&
                normalize(item.selectedRoleType) === normalize('Medical Officer')
            );
          } else if (userConfig.level === 3) {
            rolePermission = response?.data.find(
              (item) =>
                item.selectedRole === 'Approver' &&
                normalize(item.selectedRoleType) === normalize('Safety Officer')
            );
          }
        } else {
          // Default matching for non-Approver roles
          rolePermission = response?.data.find(
            (item) => item.selectedRole?.toLowerCase() === userConfig.role?.toLowerCase()
          );
        }

        if (rolePermission) {
          const hasDashboardViewAccess =
            rolePermission.permissions?.Reports_And_Dashboard?.access;
          
          if (hasDashboardViewAccess) {
            navigate('/home/reports/dashboard');
          } else {
            navigate(userConfig.nav);
          }
        } else {
          // fallback if no matching rolePermission found
          navigate(userConfig.nav);
          console.warn('No rolePermission matched');
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }

  //Copy Paste Password
  const handleNewPasswordPaste = (e) => {
    e.preventDefault();
  };


  // ==================== MOBILE SCREENS ====================
  const renderMobileLoginScreen = () => (
    <div style={{ minHeight: '100vh', padding: '20px' }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <Image
          src={updated}
          preview={false}
          style={{ height: '60px', width: '200px' }}
        />
        <Typography.Text style={{ display: 'block', marginTop: '10px', fontSize: '16px' }}>
          Labour onboarding made Instant, Simple and Verified
        </Typography.Text>
      </div>

      <Card
        title='Login to VYN Account'
        bordered={false}
        style={{
          width: '100%',
          maxWidth: '400px',
          margin: '0 auto',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}
      >
        <Form
          name='login'
          initialValues={{ userid: '', password: '', orgId: '' }}
          onFinish={onFinish}
        >
          <Form.Item
            name='userid'
            rules={[{ required: true, message: 'Please input your User Id!' }]}
            getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder='User ID'
              size='large'
            />
          </Form.Item>

          <Form.Item
            name='password'
            rules={[{ required: true, message: 'Please input your Password!' }]}
            getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder='Password'
              size='large'
              onPaste={handleNewPasswordPaste}
            />
          </Form.Item>

          <Form.Item
            name='orgId'
            rules={[{ required: true, message: 'Please input your Organisation Id!' }]}
            getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
          >
            <Input
              prefix={<ApartmentOutlined />}
              placeholder='Organisation ID'
              size='large'
            />
          </Form.Item>

          <div style={{ textAlign: 'right', marginBottom: '24px' }}>
            <Button 
              type="link" 
              onClick={() => setShowForgotPasswordMobile(true)}
              style={{ padding: 0 }}
            >
              Forgot Password?
            </Button>
          </div>

          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              loading={isUserLoading}
              icon={<LoginOutlined />}
              size='large'
              block
            >
              Log in
            </Button>
          </Form.Item>

          <div style={{ display: 'flex', gap: '8px' }}>
            <Input
              placeholder="Enter Organization ID"
              value={orgId}
              onChange={handleOrgIdChange}
              style={{ flex: 1 }}
              size="large"
              disabled={loading}
            />
            <Button
              type="dashed"
              onClick={handleSSOLogin}
              style={{ marginBottom: '15px' }}
              size="large"
              disabled={!isValidOrg || loading}
              loading={loading}
            >
              Login with SSO
            </Button>
          </div>
        </Form>
      </Card>

      <Typography.Text style={{
        display: 'block',
        textAlign: 'center',
        marginTop: '30px',
        color: '#666'
      }}>
        WIKIWORKS (c) 2023 COPYRIGHT & PATENT
      </Typography.Text>
    </div>
  );

  const renderMobileForgotPasswordScreen = () => (
    <div style={{ minHeight: '100vh', padding: '20px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Button 
          type="text" 
          icon={<ArrowLeftOutlined />}
          onClick={() => setShowForgotPasswordMobile(false)}
          style={{ paddingLeft: 0 }}
        >
          Back to Login
        </Button>
      </div>
      
      <Forgotpassword 
        onCancel={() => setShowForgotPasswordMobile(false)} 
        showCancelButton={false}
      />

      <Typography.Text style={{
        display: 'block',
        textAlign: 'center',
        marginTop: '30px',
        color: '#666'
      }}>
        WIKIWORKS (c) 2023 COPYRIGHT & PATENT
      </Typography.Text>
    </div>
  );

  // ==================== WEB SCREEN (UNCHANGED) ====================
//   const renderWebScreen = () => (
//     <Row style={{ height: '100vh' }} justify='center' align='middle'>
//     {/* <Col xs={28} md={16} style={{
//       height: '100vh',
//       backgroundImage: 'url("https://www.smartkarrot.com/wp-content/uploads/2020/12/Digital-Onboarding.jpg")',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: 'cover',
//     }}>
//       <Col style={{ display: 'flex', justifyContent: 'center' }}>
//         <Image
//           src={updated}
//           preview={false}
//           style={{ height: '70px', marginTop: '20px', width: '250px' }}
//         />
//       </Col>
//       <Col style={{ display: 'flex', justifyContent: 'center' }}>
//         <Typography.Text className='text'>
//           Labour onboarding made Instant, Simple and Verified
//         </Typography.Text>
//       </Col>
//       <h4 style={{
//         textAlign: 'center',
//         color: 'white',
//         bottom: 0,
//         position: 'absolute',
//         width: '100%',
//         left: 60,
//       }}>
//         WIKIWORKS (c) 2023 COPYRIGHT & PATENT
//       </h4>
//     </Col> */}
      
//       <Col
//   xs={28}
//   md={16}
//   style={{
//     height: '100vh',
//     position: 'relative',
//   }}
// >
//   {/* Full Image */}
//   <img
//     src={WW}    // <-- your imported image
//     alt="Login Screen"
//     style={{
//       width: '100%',
//       height: '105%',
//       objectFit: 'cover',
//     }}
//   />

//   {/* Footer Text */}
 
// </Col>

//     <Col xs={20} md={8} style={{ padding: '6px' }}>
//       <Card
//         title=' Login to VYN Account '
//         bordered={false}
//         className='login-card'
//         id='Title'
//       >
//         <Form
//           name='login'
//           initialValues={{ userid: '', password: '', orgId: '' }}
//           onFinish={onFinish}
//         >
//           {/* Your existing form items */}
//           <Form.Item
//             name='userid'
//             rules={[{ required: true, message: 'Please input your User Id!' }]}
//             hasFeedback
//           >
//             <Input prefix={<UserOutlined />} placeholder='UserId' allowClear />
//           </Form.Item>
//           <Form.Item
//             name='password'
//             rules={[{ required: true, message: 'Please input your Password!' }]}
//             hasFeedback
//           >
//             <Input.Password
//               prefix={<LockOutlined />}
//               placeholder='Password'
//               onPaste={handleNewPasswordPaste}
//             />
//           </Form.Item>
//           <Form.Item
//             name='orgId'
//             rules={[{ required: true, message: 'Please input your Organisation Id!' }]}
//             hasFeedback
//           >
//             <Input prefix={<ApartmentOutlined />} placeholder='Organisation Id' allowClear />
//           </Form.Item>

//           <Button
//             type='dashed'
//             onClick={() => setforgotPasswordOpen(true)}
//             style={{ marginBottom: '15px' }}
//           >
//             Forgot Password
//           </Button>

//           <Form.Item>
//             <Button
//               type='primary'
//               htmlType='submit'
//               loading={isUserLoading}
//               icon={<LoginOutlined />}
//             >
//               Log in
//             </Button>
//           </Form.Item>

//           <Form.Item>
//             <div style={{ display: 'flex', gap: '8px' }}>
//               <Input
//                 placeholder="Enter Organization ID"
//                 value={orgId}
//                 onChange={handleOrgIdChange}
//                 style={{ flex: 1, }}
//                 size="small"
//                 disabled={loading}
//               />
//               <Button
//                 type="dashed"
//                 onClick={handleSSOLogin}
//                 //style={{ marginBottom: '15px' }}
//                 size="medium"
//                 disabled={!isValidOrg || loading}
//                 loading={loading}
//               >
//                 Login with SSO
//               </Button>
//             </div>
//           </Form.Item>
//         </Form>
//       </Card>
//     </Col>
//   </Row>
  //   );
  
  //For Forgot Password
  // ==================== WEB SCREEN (UNCHANGED + FIX ADDED) ====================
const renderWebScreen = () => (
  <Row style={{ height: '100vh' }} justify='center' align='middle'>

    <Col
      xs={28}
      md={16}
      style={{
        height: '100vh',
        position: 'relative',
      }}
    >
      <img
        src={WW}
        alt="Login Screen"
        style={{
          width: '100%',
          height: '105%',
          objectFit: 'cover',
        }}
      />
    </Col>

    <Col xs={20} md={8} style={{ padding: '6px' }}>
      <Card
        title=' Login to VYN Account '
        bordered={false}
        className='login-card'
        id='Title'
      >

        {/* ✅ ADDED: Forgot Password Rendering */}
        {forgotPasswordOpen ? (

  <div
    // style={{
    //   width: '100%',
    //   minHeight: '350px'
            // }}
             style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <Forgotpassword
      onCancel={() => setforgotPasswordOpen(false)}
    />
  </div>

)  : (

        <Form
          name='login'
          initialValues={{ userid: '', password: '', orgId: '' }}
          onFinish={onFinish}
        >

          <Form.Item
            name='userid'
            rules={[{ required: true, message: 'Please input your User Id!' }]}
            getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
            hasFeedback
          >
            <Input
              prefix={<UserOutlined />}
              placeholder='UserId'
              allowClear
            />
          </Form.Item>

          <Form.Item
            name='password'
            rules={[{ required: true, message: 'Please input your Password!' }]}
            getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
            hasFeedback
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder='Password'
              onPaste={handleNewPasswordPaste}
            />
          </Form.Item>

          <Form.Item
            name='orgId'
            rules={[{ required: true, message: 'Please input your Organisation Id!' }]}
            getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
            hasFeedback
          >
            <Input
              prefix={<ApartmentOutlined />}
              placeholder='Organisation Id'
              allowClear
            />
          </Form.Item>

          <Button
            type='dashed'
            onClick={() => setforgotPasswordOpen(true)}
            style={{ marginBottom: '15px' }}
          >
            Forgot Password
          </Button>

          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              loading={isUserLoading}
              icon={<LoginOutlined />}
            >
              Log in
            </Button>
          </Form.Item>

          <Form.Item>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Input
                placeholder="Enter Organization ID"
                value={orgId}
                onChange={handleOrgIdChange}
                style={{ flex: 1 }}
                size="small"
                disabled={loading}
              />

              <Button
                type="dashed"
                onClick={handleSSOLogin}
                size="medium"
                disabled={!isValidOrg || loading}
                loading={loading}
              >
                Login with SSO
              </Button>

            </div>
          </Form.Item>

        </Form>

        )}

      </Card>
    </Col>

  </Row>
);


  if (isMobile) {
    return showForgotPasswordMobile 
      ? renderMobileForgotPasswordScreen() 
      : renderMobileLoginScreen();
  }

  return renderWebScreen();
}

// https://images.pexels.com/photos/14149319/pexels-photo-14149319.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load
